import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { AdditionalActivityJson } from "../../../DynamicFormsJson/MastersJSON/AdditionalActivity";
import { getStockStakeHolderType } from "../../../Slice/stockStakeHolderType.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import { getOtherTaskByStatus } from "../../../Slice/otherTask.slice";

class AdditionalActivityForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        stockHolderTypeDetail:
          this.props.stockStakeHolderTypeList?.stockStakeHolderType,
        otherTaskTypeDetail: this.props.otherTaskList?.otherTask,
      },
    };
  }

  componentDidMount() {
    const {
      getStockStakeHolderType,
      getOtherTaskByStatus,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getStockStakeHolderType({ userTypeIds: "3,4" }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      getOtherTaskByStatus().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.stockStakeHolderTypeList?.stockStakeHolderType !==
      nextProps.stockStakeHolderTypeList?.stockStakeHolderType
    ) {
      this.setState({
        dynamicMasterData: {
          ...this.state.dynamicMasterData,
          stockHolderTypeDetail:
            nextProps.stockStakeHolderTypeList?.stockStakeHolderType,
        },
      });
    }
    if (
      this.props.otherTaskList?.otherTask !== nextProps.otherTaskList?.otherTask
    ) {
      this.setState({
        dynamicMasterData: {
          ...this.state.dynamicMasterData,
          otherTaskTypeDetail: nextProps.otherTaskList?.otherTask,
        },
      });
    }
  }

  render() {
    const { dynamicMasterData } = this.state;
    return (
      <>
        <DynamicForm
          dynamicMasterData={dynamicMasterData}
          formPath={AdditionalActivityJson.formPath}
          screenTitle={AdditionalActivityJson.screenTitle}
          fieldMeta={AdditionalActivityJson.fieldMeta}
          tableColumnsToFilter={AdditionalActivityJson.tableColumnsToFilter}
          apiBaseURL={AdditionalActivityJson.apiBaseURL}
          baseIdColumn={AdditionalActivityJson.baseIdColumn}
          type={0}
          isLog={true}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stockStakeHolderTypeList: state.stockStakeHolderType,
  otherTaskList: state.otherTask,
});
const mapDispatchToProps = {
  getStockStakeHolderType,
  getOtherTaskByStatus,
  showNotification,
  showLoador,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalActivityForm);
